import React, {useState, useEffect} from 'react'
import { Row, Col } from 'antd'
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack'
import QueueAnim from 'rc-queue-anim'
import TweenOne from 'rc-tween-one'
import SmallArrows from '@/assets/images/small_arrows.png'

import Client1 from '@/assets/images/case/bg03.jpg'
import Client2 from '@/assets/images/case/bg09.jpg'
import Client3 from '@/assets/images/case/bg11.jpg'

import {getAnim} from "@/utils";
import { useNavigate } from 'react-router-dom'


type DataType =  {name: string, title: string, desc: string, url: string, index: number}

const Consult: React.FC = () => {
  const [data, setData] = useState<DataType[]>([
    {
      index: 1,
      name: '企业性质：北京某大型国有黄金珠宝专营公司',
      title: '金色纽带、金色未来人才体系培养项目',
      desc: '完善管理人员培养体系建设，打造专业高素质干部队伍',
      url: Client1
    },
    {
      index: 7,
      name: '企业性质：全国性股份制商业银行',
      title: '超大规模全线上训练营',
      desc: '云端实战・AI破局 —— 打造金融业数字化转型核心引擎',
      url: Client2
    },
    {
      index: 9,
      name: '企业性质：德资企业、全球行业技术领袖、世界500强成员',
      title: '头部外企的战略客户经营实战',
      desc: '从市场噪声中识别信号，从产品同质中实现破局',
      url: Client3
    }
  ])
  const [item, setItem] = useState<DataType>()
  const [idx, setIdx] = useState(0)
  const [flag, setFlag] = useState(true)
  const navigate = useNavigate();

  useEffect(() => {
    setItem(data[0])
  }, [])
  const imgAnim: any = getAnim()

  const handleMouseEnter = (item, index) => {
    setIdx(index)
    setItem(item)
    if(idx != index) {
      setFlag(true)
    }
  }

  const handleMouseLeave = () => {
    setFlag(false)
  }

  const handlePage = (path) => {
    navigate(path)
  }

  return (
    <div className='wrap-consult'>
      <div className='home-page'>
        <div key="title" className='title'>
          客户案例
        </div>
        <OverPack playScale={0.3} component={Row} className='wrap-consult-wrap'>
          <QueueAnim
            key="text"
            type="left"
            leaveReverse
            ease={['easeOutQuad', 'easeInQuad']}
            component={Col}
            md={11}
          >
            <QueueAnim
              component="ul"
              key="ul"
              type="left"
              ease="easeOutQuad"
            >
              {
                data.map((item, i) => (
                  <div key={i}
                       className={`wrap-consult-block ${i === idx && 'wrap-consult-active'}`}
                       onMouseEnter={() => handleMouseEnter(item, i)}
                       onMouseLeave={handleMouseLeave}>
                    <div className='consult-name'>{item?.name}</div>
                    <div className='consult-title'>{item?.title}</div>
                    <div className='consult-desc'>{item?.desc}</div>
                    {i === idx && <img className='arrows-img' src={SmallArrows} alt="" onClick={() => handlePage(`/case/${item?.index}`)}/>}
                  </div>
                ))
              }
            </QueueAnim>
          </QueueAnim>
          <TweenOne
            key="img"
            animation={imgAnim}
            resetStyle
            component={Col}
            md={12}
            style={{display: "flex", alignItems: "center"}}
          >
            <img className={`img-c ${flag ? 'img-fade' : ''}`} src={item?.url}  width="100%" alt="" />
            <div>
              {
                data.map((item, i) => (
                  <div className={`case ${i === idx ? 'case-active' : ''}`}></div>
                ))
              }
            </div>
          </TweenOne>
        </OverPack>
      </div>
    </div>
  )
}

export default Consult